import _ from 'lodash';
import React, { ReactNode, useState } from 'react';
import styled from 'styled-components';

// Material UI
import Box from '@material-ui/core/Box';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import Typography from '@material-ui/core/Typography';

export const LargeIcon = styled.img`
  height: 64px;
  object-fit: contain;
`

export const InlineIcon = styled.span`
  display: flex;
  align-items: center;

  & > svg {
    margin-right: 8px;
  }
`

interface INotice {
  icon: ReactNode;
  children: ReactNode;
}

export const Notice: React.FC<INotice> = ({ icon, children }) => {
  return <Box display="flex" alignItems="center" style={{ lineHeight: '36px' }}>
    <InlineIcon>{icon}</InlineIcon>
    <Typography style={{ lineHeight: '36px' }}>{children}</Typography>
  </Box>
}

const MAIL_OUTLINED_PATH = 'M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 4.99L4 6h16zm0 12H4V8l8 5 8-5v10z';

// Material's outlined mail, struck through; the mask cuts a gap so the slash reads on any background.
export const MailOffIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  const [maskId] = useState(() => _.uniqueId('mail-off-mask-'));

  return (
    <SvgIcon {...props} ref={ref}>
      <mask id={maskId}>
        <rect width="24" height="24" fill="white" />
        <line x1="2" y1="2" x2="22" y2="22" stroke="black" strokeWidth="5" />
      </mask>
      <path d={MAIL_OUTLINED_PATH} mask={`url(#${maskId})`} />
      <line x1="2" y1="2" x2="22" y2="22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
});
MailOffIcon.displayName = 'MailOffIcon';
